import { useEffect } from 'react';

import type { useChatContextProvider } from '@atlassian/conversation-assistant-store/controllers/chat-context/store';
import { setRovoChatContextProvider } from '@atlassian/conversation-assistant-utils/rovoChatContextProviderRegistry';

import { buildCanonicalRovoChatContext } from './buildCanonicalRovoChatContext';

type ChatContextStoreActions = ReturnType<typeof useChatContextProvider>;

/**
 * Registers the chat-context store as the Enterprise HER pull-context provider
 * for the lifetime of the Conversation Assistant mount.
 */
export function useRegisterRovoChatContextProviderForEnterpriseHer(
	chatContextStoreActions: ChatContextStoreActions,
	productKey?: string,
): void {
	useEffect(() => {
		setRovoChatContextProvider(() =>
			buildCanonicalRovoChatContext({
				chatContextStoreActions,
				productKey,
			}),
		);

		return () => {
			setRovoChatContextProvider(null);
		};
	}, [chatContextStoreActions, productKey]);
}
